export default {
  SET_SUBSCRIPTIONS_DETAILS: 'subscriptions/SET_SUBSCRIPTIONS_DETAILS',
  INCREASE_USED_DISCOUNTS_COUNTER: 'subscriptions/INCREASE_USED_DISCOUNTS_COUNTER',
};
